module.exports = {
  MessageDeliverStatus: {
    UPLOADING_FILE: 'uploading_file',
    SENDING: 'sending',
    FAILED: 'failed',
    SUCCEED: 'succeed'
  }
}
